import React from "react";
import FormGroupTextInput from "../formGroupTextInput";
import FormGroupSelectMultiple from "../formGroupSelectMultiple";
import _ from "lodash";
import CustomCheckbox from "../General/customCheckbox";
import SolicitorGroupTechnicalUnderwriters from "./solicitorGroupTechnicalUnderwriters";
import FormGroupSelectInput from "../formGroupSelectInput";
import { LEGAL_ADVICE_TEXT } from "../../helpers/variables";
import { FormGroup } from 'arag-ui-lib';

const SolicitorGroupGeneralTab = (props) => {
    const {handleWordingCategoryChange} = props;
    const {wordingCategoriesAsListOptions} = props;

    return (
        <div>
            <FormGroupTextInput
                Name="name"
                Value={props.SolicitorGroup.name}
                Label="Name"
                Required={true}
                InputWrapper="col-sm-9 formGroup-textInput-input-wrapper"
                RightWrapper=""
                HandleInputChange={props.HandleInputChange}/>
            <FormGroup
                labelSize={"col-xs-3"}
                inputSize={"col-xs-9"}
                label={<div className="formGroup-textInput-label">{LEGAL_ADVICE_TEXT}s<span>{' '}*</span></div>}
                variant={"searchableList"}
                inputProps={{
                    inputValue: props.lawsysFirms.suggestionFieldValue,
                    onInputChange: (value, action) => props.onMultiInputChanged(LEGAL_ADVICE_TEXT, value, action),
                    onChange: (value) => props.onMultiSelect(LEGAL_ADVICE_TEXT, value),
                    instanceId: LEGAL_ADVICE_TEXT,
                    value: props.lawsysFirms.selectedLawsysFirmsDropdown.map(l => ({value: l.id, label: l.name})),
                    options: [
                        ...props.lawsysFirms.selectedLawsysFirmsDropdown.map(l => ({value: l.id, label: l.name})),
                        ...props.lawsysFirms.lawsysFirmsFiltered.map(l => ({value: l.id, label: l.name}))
                    ],
                    isLoading: props.lawsysFirms.fetching,
                    placeholder: `Quick search for ${LEGAL_ADVICE_TEXT.toLowerCase()}s`,
                    noOptionsText: `No ${LEGAL_ADVICE_TEXT} found`,
                    minSearchCharacters: 3,
                    isMulti: true,
                }}
            />
            <SolicitorGroupTechnicalUnderwriters
                underwriters={props.SolicitorGroup.underwriters}
                addUnderwriter={props.addUnderwriter}
                editUnderwriter={props.editUnderwriter}
                removeUnderwriter={props.removeUnderwriter}
                solicitorGroupUnderwriters={props.SolicitorGroup.groupUnderwriters}
            />
            <FormGroupSelectInput
                Multiple={false} Name="selectedWordingCategory"
                Value={props.SolicitorGroup.selectedWordingCategory || ''}
                Required={true}
                SelectStyle={'form-control solicitorGroup-select-underwriter'}
                LeftWrapper="col-sm-3"
                CenterWrapper="col-sm-9 formGroupSelectInput-select-wrapper"
                RightWrapper=""
                HandleInputChange={handleWordingCategoryChange} Label="Wording category"
                Options={wordingCategoriesAsListOptions}
            />
            <FormGroupSelectMultiple
                Name="selectedWorkSources"
                HandleCheckedState={props.HandleCheckedState}
                HandleInputChange={props.handleSelectMultipleChange}
                Label="Work Sources"
                Required={false}
                Options={props.SolicitorGroup.workSources}
                LeftWrapper="col-sm-3"
                CenterWrapper="col-sm-9 formGroupSelectInput-select-wrapper"
                RightWrapper=""
                InputWrapper="col-sm-9 formGroup-textInput-input-wrapper"
            />
            <FormGroupSelectMultiple
                Name="selectedCaseTypes"
                HandleCheckedState={props.handleCaseTypesCheckedState}
                HandleInputChange={props.handleSelectMultipleCaseTypes}
                Label="Case types"
                Required={true}
                Options={props.caseTypes.map(item => {return {name:item.name, id: item.id}})}
                LeftWrapper="col-sm-3"
                CenterWrapper="col-sm-9 formGroupSelectInput-select-wrapper"
                RightWrapper=""
                InputWrapper="col-sm-9 formGroup-textInput-input-wrapper"
            />
            {
                props.filteredSubCases.length > 0?
                    <FormGroupSelectMultiple
                        Name="selectedSubCaseTypes"
                        HandleCheckedState={props.handleSubCaseTypesCheckedState}
                        HandleInputChange={props.handleSelectMultipleSubCaseTypes}
                        Label="Sub case types"
                        Required={false}
                        Options={props.filteredSubCases.map(item => {return {name:item.name, id: item.id}})}
                        LeftWrapper="col-sm-3"
                        CenterWrapper="col-sm-9 formGroupSelectInput-select-wrapper"
                        RightWrapper=""
                        InputWrapper="col-sm-9 formGroup-textInput-input-wrapper"
                    />
                    :
                    null
            }
            <div className="form-group">
                <div className="col-sm-3"/>
                <div className="col-sm-9">
                    <h4>Selected {LEGAL_ADVICE_TEXT}s</h4>
                    {props.SolicitorGroup.selectedSolicitors.length > 0 ?
                        <ul className="unorderedListNoBulletsAndSpace">
                            {props.SolicitorGroup.selectedSolicitors.map(value => {
                                return <li key={value.id}>{value.name}</li>
                            })}
                        </ul>
                        :
                        null
                    }
                    <h4>Selected WorkSources</h4>
                    {props.SolicitorGroup.selectedWorkSources.length > 0 ?
                        <ul className="unorderedListNoBulletsAndSpace">
                            {props.SolicitorGroup.selectedWorkSources.map(value => {
                                return <li key={value.id}>{value.name}</li>
                            })}
                        </ul>
                        :
                        null
                    }

                </div>
            </div>
            <div className={'form-group'}>
                <div className={'col-sm-9 col-sm-offset-3'}>
                    <CustomCheckbox
                        disabled={props.SolicitorGroup.selectedWorkSources.length === 0}
                        leftClassName={'col-sm-3'}
                        centerClassName={'col-sm-9'}
                        checked={props.SolicitorGroup.requiredWorkSource}
                        label={'Cannot submit application without specifying a work source'}
                        name={'requiredWorkSource'}
                        _onChange={(evt) =>  props.HandleInputChange(evt.target.name, evt.target.checked)}
                    />
                </div>
            </div>
            <div className={'form-group'}>
                <div className={'col-sm-9 col-sm-offset-3'}>
                    <CustomCheckbox
                        leftClassName={'col-sm-3'}
                        centerClassName={'col-sm-9'}
                        checked={props.SolicitorGroup.attachXmlInEmails}
                        label={'Attach XML file in email communications'}
                        name={'attachXmlInEmails'}
                        _onChange={(evt) =>  props.HandleInputChange(evt.target.name, evt.target.checked)}
                    />
                </div>
            </div>
            {
                props.SolicitorGroup.selectedCaseTypes.length > 0?
                    <div className="form-group">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-9">
                            <h4>Selected Case Types</h4>
                            <p>{' If you would like to automatically refer all applications of a certain' +
                            ' case or sub case type, please select the appropriate user group ' +
                            '(Medical Expert, Technical Underwriter, Underwriter) below each case/sub case type.'}</p>
                            {props.SolicitorGroup.selectedCaseTypes.length > 0 ?
                                <ul className="unorderedListNoBulletsAndSpace">
                                    {props.SolicitorGroup.selectedCaseTypes.map(value => {
                                        return <li key={value.id}>
                                            <div className="row">
                                                <div className="col-sm-12">{value.name}</div>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <div className="col-sm-4">
                                                            <input
                                                                id={'referToByCaseTypeMedical ' + value.id}
                                                                type="checkbox"
                                                                className="appFormRefSettings-check_box"
                                                                checked={props.SolicitorGroup.referToByCaseType[value.id].medical}
                                                                name="referToByCaseType"
                                                                onChange={(evt) => props._changeReferToByCaseType(value.id, 'medical', evt.target.checked)}/>
                                                            <label htmlFor={'referToByCaseTypeMedical ' + value.id}></label>
                                                            <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font">Medical Expert</span>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <input
                                                                id={'referToByCaseTypeTuw ' + value.id}
                                                                type="checkbox"
                                                                className="appFormRefSettings-check_box"
                                                                checked={props.SolicitorGroup.referToByCaseType[value.id].tuw}
                                                                name="includeDraft"
                                                                onChange={(evt) => props._changeReferToByCaseType(value.id, 'tuw', evt.target.checked)}/>
                                                            <label htmlFor={'referToByCaseTypeTuw ' + value.id}></label>
                                                            <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font">Technical Underwriter</span>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <input
                                                                id={'referToByCaseTypeCmu ' + value.id}
                                                                type="checkbox"
                                                                className="appFormRefSettings-check_box"
                                                                checked={props.SolicitorGroup.referToByCaseType[value.id].cmu}
                                                                name="includeDraft"
                                                                onChange={(evt) => props._changeReferToByCaseType(value.id, 'cmu', evt.target.checked)}/>
                                                            <label htmlFor={'referToByCaseTypeCmu ' + value.id}></label>
                                                            <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font">Underwriter</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    })}
                                </ul>
                                :
                                null
                            }
                            <h4>Selected Sub case types</h4>
                            {props.SolicitorGroup.selectedSubCaseTypes.length > 0 ?
                                <ul className="unorderedListNoBulletsAndSpace">
                                    {props.SolicitorGroup.selectedSubCaseTypes.map(value => {
                                        return <li key={value.id}>
                                            <div className="row">
                                                <div className="col-sm-12">{value.name}</div>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <div className="col-sm-4">
                                                            <input
                                                                id={'referToBySubCaseTypeMedical ' + value.id}
                                                                type="checkbox"
                                                                className="appFormRefSettings-check_box"
                                                                checked={props.SolicitorGroup.referToBySubCaseType[value.id].medical}
                                                                name="referToBySubCaseType"
                                                                onChange={(evt) => props._changeReferToBySubCaseType(value.id, 'medical', evt.target.checked)}/>
                                                            <label htmlFor={'referToBySubCaseTypeMedical ' + value.id}></label>
                                                            <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font">Medical Expert</span>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <input
                                                                id={'referToBySubCaseTypeTuw ' + value.id}
                                                                type="checkbox"
                                                                className="appFormRefSettings-check_box"
                                                                checked={props.SolicitorGroup.referToBySubCaseType[value.id].tuw}
                                                                name="referToBySubCaseTypeCmu"
                                                                onChange={(evt) => props._changeReferToBySubCaseType(value.id, 'tuw', evt.target.checked)}/>
                                                            <label htmlFor={'referToBySubCaseTypeTuw ' + value.id}></label>
                                                            <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font">Technical Underwriter</span>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <input
                                                                id={'referToBySubCaseTypeCmu ' + value.id}
                                                                type="checkbox"
                                                                className="appFormRefSettings-check_box"
                                                                checked={props.SolicitorGroup.referToBySubCaseType[value.id].cmu}
                                                                name="referToBySubCaseType"
                                                                onChange={(evt) => props._changeReferToBySubCaseType(value.id, 'cmu', evt.target.checked)}/>
                                                            <label htmlFor={'referToBySubCaseTypeCmu ' + value.id}></label>
                                                            <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font">Underwriter</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    })}
                                </ul>
                                :
                                null
                            }

                        </div>
                    </div>
                    :
                    null
            }
        </div>
    )
};

export default SolicitorGroupGeneralTab;
